import type { FilterState } from '../../store';

export interface InitialFilterStateInput {
  initialPage: number;
  initialSort: FilterState['sortBy'];
  initialSearch: string;
  initialSelectedFandoms: string[];
  initialSelectedTags: string[];
  initialSelectedUniverses: string[];
  initialSelectedStatuses: string[];
  initialSelectedRatings: string[];
  initialSelectedCharacters: string[];
  initialSelectedPairingCharacters: string[];
}

/**
 * Builds the filter reducer state from SSR props only. Listing-restore snapshots
 * are applied after mount so hydration matches the server render.
 */
export const buildInitialFilterState = ({
  initialPage,
  initialSort,
  initialSearch,
  initialSelectedFandoms,
  initialSelectedTags,
  initialSelectedUniverses,
  initialSelectedStatuses,
  initialSelectedRatings,
  initialSelectedCharacters,
  initialSelectedPairingCharacters,
}: InitialFilterStateInput): FilterState => ({
  activeTab:
    initialSort === 'updated' || initialSort === 'hotNew' || initialSort === 'bestMonth'
      ? 'popular'
      : (initialSort as 'popular' | 'newest' | 'best'),
  searchQuery: initialSearch,
  sortBy: initialSort,
  currentPage: initialPage,
  selectedFandoms: initialSelectedFandoms,
  selectedTags: initialSelectedTags,
  selectedUniverses: initialSelectedUniverses,
  selectedStatuses: initialSelectedStatuses,
  selectedRatings: initialSelectedRatings,
  selectedDirections: [],
  selectedCharacters: initialSelectedCharacters,
  selectedPairingCharacters: initialSelectedPairingCharacters,
  isMobileFiltersOpen: false,
});
